import React from 'react'

function PaymentPanding() {
  return (
    <div>PaymentPanding</div>
  )
}

export default PaymentPanding